import get from 'lodash.get';

const getSettings = (rootState) => get(rootState, 'ws.site.meta.settings', {});

export default getSettings;
